import axios from "axios";
import { get } from "lodash";
import set from "lodash/set";

import { getUserToken } from "../modules/auth";
import formatError from "../helpers/formatError";
import { getErrorCodeHandler } from "./errorCodeHandlers";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Captured from the middleware factory below so error-code handlers
// (registered at module load via the registry) can access the Redux store.
let storeRef = null;

axios.interceptors.response.use(
  response => response,
  error => {
    const code = get(error, "response.data.code");
    const handler = getErrorCodeHandler(code);
    if (handler && storeRef) {
      handler(error, storeRef);
    }

    const errorMsg = formatError(error, "Server Error.");
    return Promise.reject(errorMsg);
  }
);

const addAuthorizationToHeaders = (state, config) => {
  const userToken = getUserToken(state);

  if (!userToken) {
    localStorage.setItem('token', null)
    return config;
  }

  set(config, "headers.Content-Type", "application/json");
  set(config, "headers.Authorization", `Bearer ${userToken}`);
  localStorage.setItem('token', userToken)

  return config;
};

const authorizationProvider = store => next => action => {
  storeRef = store;
  axios.interceptors.request.use(config => {
    const state = store.getState(store);
    return addAuthorizationToHeaders(state, config);
  });

  return next(action);
};

export default authorizationProvider;
